import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=94e0e3f6&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e0e3f6",
  null
  
)

export default component.exports